import React from "react";
import { Link } from "react-router-dom";

function HiddenNavbar() {
    return (
        <nav
            aria-label="Pomoćna navigacija"
            style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                padding: 0,
                margin: "-1px",
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                border: 0,
            }}
        >
            <Link to="/">Početna</Link>
            <Link to="/stanovi/">Stanovi</Link>
            <Link to="/oprema-stanova/">Oprema i parking</Link>
            <Link to="/parking/">Parking</Link>
            <Link to="/kontakt/">Kontakt</Link>
        </nav>
    );
}

export default HiddenNavbar;